import { EParkingType } from '@/packages/api-models/common/json_query';

import { type IParking } from '../types';

export const PARKING_TYPES_LIST: IParking[] = [
  { label: 'Неважно', value: null },
  { label: 'Наземная', value: EParkingType.Ground },
  { label: 'Многоуровневая', value: EParkingType.Multilevel },
  { label: 'Подземная', value: EParkingType.Underground },
];

export const EXTENDED_PARING_TYPES: IParking[] = [
  ...PARKING_TYPES_LIST,
  { label: 'На крыше', value: EParkingType.Rooftop },
];
